<template>
    <HeaderBar @doSearch="doSearch"></HeaderBar>
    <div class="q_main" id="main_container">
        <MySitesBar></MySitesBar>
        <div class="q_result_bar">
            <div class="q_result_text">" {{ keyword }} "的搜索结果：</div>
            <div :class="site_class_name" v-on:click="clickSiteBar()">站点({{ this.s_links.length}})</div>
            <div :class="tag_class_name" v-on:click="clickTagBar()">标签({{ this.tags.length}})</div>
            <div class="q_no_data_text" v-if="tags.length<1">{{ no_data_tag_text }}</div>
            <div class="tag_items" v-else>
                <div v-for="(s_item) in tags" v-bind:key="s_item.id" class="tag_item">
                    <span :class="s_item.class_name" v-on:click="clickTag(s_item.id,s_item.type,s_item.name)">
                        {{ s_item.name }}
                    </span>
                </div>
            </div>
        </div>
        <div class="q_result_main">
            <div class="q_no_data_text" v-if="links.length<1">{{ no_data_links_text }}</div>
            <div v-else>
                <div class="tag_title">{{ tag_title }}</div>
                <div v-if="show_more_items">
                    <div v-for="f_item in links" v-bind:key="f_item.id" class="tag_links">
                        <div v-if="!f_item.tags || f_item.tags.length==0" class="link_items">
                            <div v-for="s_item in f_item.items" v-bind:key="s_item.id" class="link_item">
                                <a draggable="true" @dragstart="dragStart" :id="s_item.id" :name="s_item.icon" :href="s_item.url" target="_blank" v-on:click="clickSite(s_item.id)">
                                    <div>
                                        <img :src="!s_item.icon?'':s_item.icon"/>
                                    </div>
                                    <span>{{ s_item.name }}</span>
                                </a>
                            </div>
                        </div>
                        <div v-else-if="f_item.tags && f_item.tags.length>0">
                            <div v-for="s_item in f_item.tags" v-bind:key="s_item.id" class="sub_tag_links">
                                <div class="sub_links_title" :id="'t_'+s_item.id">{{ s_item.name }}</div>
                                <div class="link_items">
                                    <div v-for="t_item in s_item.linkItems" v-bind:key="t_item.id" class="link_item">
                                        <a draggable="true" @dragstart="dragStart" :id="t_item.id" :name="t_item.icon" :href="t_item.url" target="_blank" v-on:click="clickSite(t_item.id)">
                                            <div>
                                                <img :src="!t_item.icon?'':t_item.icon"/>
                                            </div>
                                            <span>{{ t_item.name }}</span>
                                        </a>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="link_items">
                    <div v-for="s_item in links" v-bind:key="s_item.id" class="link_item">
                        <a draggable="true" @dragstart="dragStart" :id="s_item.id" :name="s_item.icon" :href="s_item.url" target="_blank" v-on:click="clickSite(s_item.id)">
                            <div>
                                <img :src="!s_item.icon?'':s_item.icon"/>
                            </div>
                            <span>{{ s_item.name }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <FooterBar></FooterBar>
</template>
<script>
/* eslint-disable no-unused-vars */
import http from '../http.js';
import { ElMessage } from 'element-plus'
import HeaderBar from '@/components/HeaderBar.vue';
import FooterBar from '@/components/FooterBar.vue';
import MySitesBar from '@/components/MySitesBar.vue';
    export default {
        name: 'SiteSearch',
        components:{
            HeaderBar,
            FooterBar,
            MySitesBar
        },
        data(){
            return{
                keyword:"",
                tags:[],
                links:[],
                s_links:[],
                tagLinks:[],
                groupTagLinks:[],
                no_data_tag_text:"",
                no_data_links_text:"",
                tag_class_name:"result_item_title",
                site_class_name:"result_item_title",
                show_more_items:false,
                tag_title:""
            }
        },
        mounted(){
            var params = new URLSearchParams(window.location.search);
            var keyword = params.get('q');
            if(keyword == undefined || keyword==""){
                return
            }
            this.doSearch(keyword);
        },
        methods:{
            dragStart(event){
                var target = event.target;
                console.log("event.target=",event.target)
                console.log("event.target.tagName=",event.target.tagName)
                if(event.target.tagName == "IMG"){
                    target = event.target.parentElement.parentElement;
                }
                if(target != undefined && target.tagName == "A"){
                    var url = target.href;
                    var name = target.text;
                    var id = target.id;
                    var icon = target.name;
                    const siteItem = { id:id, url:url,name:name,icon:icon };
                    event.dataTransfer.setData("text", JSON.stringify(siteItem));
                }
            },
            clickSiteBar(){
                this.tag_title="搜索站点结果";
                this.site_class_name="result_item_title_select";
                this.tag_class_name="result_item_title";
                this.tags.forEach((item)=>{
                    item.class_name="tag_item_text";
                });
                this.links=this.s_links;
                this.show_more_items = false;
            },
            clickTagBar(){
                if(this.tags.length>0 && this.tag_class_name!="result_item_title_select"){
                    var id = this.tags[0].id;
                    var type =  this.tags[0].type;
                    this.clickTag(id,type,this.tags[0].name);
                }
                this.site_class_name="result_item_title";
                this.tag_class_name="result_item_title_select";
                
            },
            clickTag(tag_id,type,name){
                this.tag_title=name;
                if(type==0){
                    this.show_more_items = true;
                }else{
                    this.show_more_items = false;
                }
                this.site_class_name="result_item_title";
                this.tag_class_name="result_item_title_select";
                this.tags.forEach((item)=>{
                    item.class_name="tag_item_text";
                    if(item.id == tag_id && item.type==type){
                        item.class_name="tag_item_text_selected";
                    }
                });
                for(var i=0;i<this.groupTagLinks.length;i++){
                    var d_id = type+"_"+tag_id;
                    if(this.groupTagLinks[i].tag_id==d_id){
                        this.links=this.groupTagLinks[i].links;
                        return
                    }
                }
                http.post('/getTagLinks',{"tag_id":tag_id,"type":type})
                    .then(response => {
                        this.links=response;
                        var d_id = type+"_"+tag_id;
                        this.groupTagLinks.push({"tag_id":d_id,"links":this.links})
                    })
                    .catch(function (error) { // 请求失败处理
                        console.log(error);
                    });
            },
            doSearch(param){
                this.show_more_items = false;
                if(param==""){
                    ElMessage({
                        message: '请输入搜索关键字！',
                        type: 'warning',
                        offset: 80
                    })
                    return;
                }
                this.keyword = param
                http.post('/searchLinks',{"keyword":param})
                .then(response => {
                    this.links=response;
                    this.s_links=response;
                    this.site_class_name="result_item_title_select";
                    this.tag_class_name="result_item_title";
                    if(this.s_links.length<1){
                        this.no_data_links_text="没有查到相关站点！"
                    }else{
                        this.tag_title="搜索站点结果";
                    }
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
                http.post('/searchTags',{"keyword":param})
                .then(response => {
                    this.tags=response;
                    this.tags.forEach((item)=>{
                        item.class_name="tag_item_text";
                    });
                    this.no_data_tag_text="没有查到相关标签！"
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            clickSite(id){
                http.post('/linkClick',{"id":id,"type":1})
                .then(response => {
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped>
@import '../assets/styles.css';
    .q_main{
        width: 1280px;
        margin: 0 auto;
        margin-top: 70px;
        position: relative;
        display: flex;
        flex-direction: row;
        min-height: calc(100vh - 125px);
    }
    .q_result_bar{
        width: 240px;
    }
    .result_item_title,.result_item_title_select{
        border-radius:3px;
        text-align: center;
        padding: 10px 0px;
        margin-top: 10px;
        cursor: pointer;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none;    /* Firefox */
        -ms-user-select: none;     /* IE/Edge */
        user-select: none;         /* 标准语法 */
        display: flex;
        align-items: center; /* 垂直居中 */
        justify-content: center; /* 水平居中，如果也需要水平居中的话 */
    }
    .result_item_title{
        background-color: #e1e2e4;
        color:gray;
    }
    .result_item_title:hover{
        background-color: #2486b9;
        color:white;
    }
    .result_item_title_select{
        background: url('../assets/right-white.png') no-repeat #2486b9;
        background-position: right 5px center;
        background-size:16px 16px;
        background-color: #2486b9;
        color:white;
    }
    
    .tag_title{
        text-align: left;
        font-weight: bold;
        padding-bottom: 10px;
        padding-left: 10px;
    }
    .q_result_main{
        padding-top: 20px;
        width: 1040px;
    }
    .q_group{
        margin-bottom: 20px;
    }
    .sub_links_title{
        text-align: left;
        font-size: 15px;
        font-weight: bold;
        color: #404040;
        padding-bottom: 10px;
        padding-left: 20px;
    }
    .q_result_text{
        text-align: left;
        color: rgb(83, 82, 82);
        margin-bottom: 10px;
    }

    .q_no_data_text{
        color: rgb(175, 173, 173);
        font-size: 14px;
        padding: 20px 20px;
    }
    
    .tag_items{
        display: flex;
        flex-wrap: wrap;
        max-height: 360px;
    }
    .tag_items{
        padding: 10px 0px 0px 0px;
    }
    .tag_items {
        overflow-y: scroll;
    }
    .tag_items::-webkit-scrollbar {
        width: 4px;
    }
    .tag_items::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #2486b9;
    }
    .tag_items::-webkit-scrollbar-track {
        border-radius: 0;
        background: white;
    }
    .tag_item{
        width: 78px;
        margin-bottom: 10px;
    }

    .tag_item_text,.tag_item_text_selected{
        padding: 3px 5px;
        color: #2486b9;
        border:1px solid white;
        font-size: 14px;
        cursor: pointer;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none;    /* Firefox */
        -ms-user-select: none;     /* IE/Edge */
        user-select: none;         /* 标准语法 */
    }
    .tag_item_text_selected{
        color:white;
        background-color: #2486b9;
        border:1px solid #2486b9;
        border-radius:3px;
    }
    .tag_item span:hover{
        color:white;
        background-color: #2486b9;
        border:1px solid #2486b9;
        border-radius:3px;
    }

    .link_items{
        display: flex;
        flex-flow:row wrap;
        margin-left: 20px;
    }

    .link_item{
        font-size: 14px;
        width: 140px;
        margin-bottom: 20px;
        margin-left: 20px;
    }

    .link_item a{
        display: flex;
        flex-direction: row;
    }
    .link_item a div{
        width: 16px;
        height: 16px;
        display: inline;
        margin:2px 3px 0px 0px;
    }
    .link_item a span{
        font-size: 14px;
    }
    .link_item a div img{
        width: 16px;
        height: 16px;
        vertical-align: top;
    }
</style>